import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import dealServiceSteps from "./dealServiceSteps";
import GroupButtons from "../../../../../ui/button/groupButtons";
import {
  TKeyOfDataWizardDealService,
  TStringKeysOfIFillDataWizardDealService,
} from "..";
import { ESideDeal } from "../../../../../shared/wizard/steps/types";

interface IStepDealService_2 {
  onChange: (
    data: ESideDeal,
    key: TStringKeysOfIFillDataWizardDealService
  ) => void;
  data: ESideDeal | null;
  onReset: (keys: TKeyOfDataWizardDealService[], data?: number[]) => void;
  isNextStepDisabled: boolean;
}

const StepDealService_2 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IStepDealService_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(dealServiceSteps.step_1);
    onReset(["sideDeal"]);
  };

  const handleNextStep = () => {
    goToStep(dealServiceSteps.step_3);
  };

  const handleChange = (data: ESideDeal) => {
    onChange(data, "sideDeal");
  };

  return (
    <BaseStep
      text="Ваша сторона сделки:"
      nextStep={handleNextStep}
      prevStep={handlePrevStep}
      isNextStepDisabled={isNextStepDisabled}
    >
      <GroupButtons
        data={[
          {
            onClick: () => handleChange(ESideDeal.Purchaser),
            label: "Покупатель",
            variant: data === ESideDeal.Purchaser ? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(ESideDeal.Seller),
            label: "Продавец",
            variant: data === ESideDeal.Seller ? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(ESideDeal.Realtor),
            label: "Риелтор",
            variant: data === ESideDeal.Realtor ? "dark" : "lightDark",
          },
        ]}
      />
    </BaseStep>
  );
};

export default StepDealService_2;
